import { setFilterDistrict, setFilterSport, setFilterState } from 'app/imports/App.actions'
import { UISpinner } from 'features/UI'
import { useAppDispatch } from 'hooks'
import { ReactNode, useEffect, useMemo } from 'react'
import { getQueryParams } from 'utils'
import { useGetDistrictsQuery, useGetSportsQuery, useGetStateByIdQuery } from '../../state/Init.rtk'
import * as Styled from './InitData.styled'

export function InitData({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch()

  const { state, district, sport } = getQueryParams()
  const { data: stateData, isLoading: isStateLoading } = useGetStateByIdQuery(state, {
    skip: !state,
  })

  const { data: districtData, isLoading: isDistrictsLoading } = useGetDistrictsQuery(state, {
    skip: !district,
  })

  const { data: sportsData, isLoading: isSportsLoading } = useGetSportsQuery(
    { stateId: state, districtId: district },
    {
      skip: !state || !district,
    },
  )

  const isLoading = useMemo(() => {
    return isStateLoading && isDistrictsLoading && isSportsLoading
  }, [isDistrictsLoading, isSportsLoading, isStateLoading])

  useEffect(() => {
    if (stateData) {
      dispatch(setFilterState(stateData))
    }

    if (districtData) {
      // find district by id from query param
      const districtValue = districtData.items.find((districtItem) => districtItem.id === district)
      dispatch(setFilterDistrict(districtValue || null))
    }
  }, [dispatch, district, districtData, stateData])

  useEffect(() => {
    if (sportsData && sportsData.items) {
      // find sport by id from query param or get first sport
      let sportItem = sportsData.items.find((item) => item.id === sport)
      if (!sportItem) {
        sportItem = sportsData.items.find((item) => !item.isParent)
      }

      if (!sportItem) return

      dispatch(setFilterSport(sportItem))
    }
  }, [dispatch, sport, sportsData])

  if (!state || !district) {
    return <Styled.ErrorTitle>Widget is not configured</Styled.ErrorTitle>
  }

  if (isLoading) {
    return <UISpinner />
  }

  return <>{children}</>
}
